module.exports = __webpack_public_path__ + "img/Mesut Ozil.a11c8e35.png";